import { useMemo } from "react";
import { IFiguresPickerData } from "src/api/server/extended-search.types";
import { mapStoreFiguresToSearchTableFigures } from "src/components/pages/search/components/table/helpers/map-store-figures-to-search-table-figures";
import { ISearchTableFigure } from "src/components/pages/search/components/table/search-table.types";
import { ISearchRequestParamsOmitCountry } from "src/components/pages/search/search.types";

export const useTableFigures = (
    figuresPicker: IFiguresPickerData | undefined,
    searchParams: ISearchRequestParamsOmitCountry | null
): ISearchTableFigure[] => {
    const selectedFigureIds = searchParams?.selectedFigures ?? [];
    const selectedFigureIdsKey = JSON.stringify(selectedFigureIds);

    return useMemo(
        () => mapStoreFiguresToSearchTableFigures(figuresPicker, selectedFigureIds),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [figuresPicker, selectedFigureIdsKey]
    );
};
